import { connect } from 'react-redux';
import CommandBar from './command_bar';
import { openPanel } from '../../actions/panel';
import {
  zoomIn, zoomOut, resetZoom, setSilhouette, hideSilhouette
} from '../../actions/canvas';
import { addCurrentWallToCart } from '../../actions/cart';
import { undo } from '../../actions/undo';
import { totalPrice } from '../../selectors/work_sizes';

const mapStateToProps = (state) => {
  const {
    canvas: {
      name, works, currency
    },
    panel: { info }
  } = state;
  return {
    name,
    currency,
    detailsVisible: !!info,
    totalPrice: totalPrice(state),
    works,
    hasWorks: !!(works || []).length
  };
};

export default connect(mapStateToProps, {
  openPanel,
  zoomIn,
  zoomOut,
  resetZoom,
  undo,
  addCurrentWallToCart,
  setSilhouette,
  hideSilhouette
})(CommandBar);
